export default {"src":"__ASTRO_ASSET_IMAGE__fa03e10e__","width":110,"height":28,"format":"svg"}